const produce = require("immer").produce;

const camelCase = require("camelcase");

const initState = {
  tags: []
};

module.exports = function (state = initState, action) {
  switch (action.type) {
    case "OPEN_STACK":
      return produce(state, draft => {
        draft.tags.push({
          tag: action.connectTag,
          stack: action.stack,
        });
      });
    case "CLOSE_STACK":
      return produce(state, draft => {
        if (draft.tags.length) {
          const last = draft.tags.pop();
          if (action.key) {
            if (last.stack?.[action.key] !== action.value) {
              draft.tags.push(last);
            }
          }
        }
      });
    case "WORKSPACE_DELETE_ALL_ELEMENTS":
      return produce(state, draft => {
        Object.keys(action.toClean).forEach(type => {
          const cachedKey = camelCase(["cached", type]);
          const keys = Array.from(globalThis[cachedKey]?.keys() || []);
          action.toClean[type].forEach(uid => {
            keys.filter(k => k.split("_")[1] === uid).forEach(k => globalThis[cachedKey]?.delete(k));
          });
        });
      });
    case "WORKSPACE_DELETE_ELEMENTS":
      return produce(state, draft => {
        const cachedKey = camelCase(["cached", action.key]);
        const keys = Array.from(globalThis[cachedKey]?.keys() || []);
        action.uids.forEach(uid => {
          keys.filter(k => k.split("_")[1] === uid).forEach(k => globalThis[cachedKey]?.delete(k));
        });
      });
    default:
      if (action.type.includes("OPEN_FORMCONTROL_") && "stack" in action) {
        return produce(state, draft => {
          draft.tags.push({
            tag: action.stack.connectTag,
            stack: action.stack,
          });
        });
      }
      return state;
  }
};
